import {
  SET_VALIDATED,
  SET_PARAMETERS,
  SET_OBJECT,
  SET_LOADING,
  SET_PRIMARY_VERSION,
  SET_SAVED,
  RESET_VALIDATION,
  SET_ACTIVE_TAB,
  SET_OBJECT_COUNT,
  RESET_STATE
} from 'constants/actionTypes';

export const initialObjectState = {
  tabs: [], // json from API
  validated: false,
  uri: null,
  parentUri: null,
  parentFolder: null,
  loading: false,
  primaryVersion: null,
  saved: false,
  activeTab: 0
};

export default function(state = initialObjectState, action) {
  switch (action.type) {
  case RESET_STATE:
    return {
      ...initialObjectState
    };

  case SET_PARAMETERS:
    return {
      ...state, ...action.parameters
    };

  case SET_VALIDATED:
    if (action.modalOpen) {
      return state;
    }
    return {
      ...state,
      validated: true
    };

  case SET_SAVED:
    return {
      ...state,
      saved: true
    };

  case RESET_VALIDATION:
    return {
      ...state,
      validated: false,
      saved: false
    };

  case SET_ACTIVE_TAB:
    return {
      ...state,
      activeTab: action.value
    };

  case SET_OBJECT:
    return {
      ...state,
      tabs: action.object.tabs,
      primaryVersion: action.object.primaryVersion,
      parentFolder: action.object.parent,
      museum: action.object.museum,
      view: action.object.view || state.view,
      uri: action.object.uri || state.uri,
      validated: false,
      saved: false,
      ...action.parameters
    };
  case SET_OBJECT_COUNT: 
    return {
      ...state,
      objectCount: action.objectCount
    };

  case SET_LOADING:
    return {
      ...state,
      loading: action.value
    };

  case SET_PRIMARY_VERSION:
    return {
      ...state,
      primaryVersion: action.primaryVersion
    };

  default:
    return state;
  }
}